/** Activity-first partition: additive Magnetworks only, no navigation changes. */
export const MAGNETWORKS_FLOW = {
  "magnetworks-prelude": [
    {
      "id": "mw-prelude-1",
      "title": "Meet Pip",
      "purpose": "Watch or read Pip’s mystery",
      "blockIds": [
        "mw-story-video"
      ]
    },
    {
      "id": "mw-prelude-2",
      "title": "Rescue rule",
      "purpose": "Recognize the challenge",
      "blockIds": [
        "mw-mission-rule",
        "mw-swan-prelude",
        "mw-prelude-gate"
      ]
    }
  ],
  "magnetworks-wonder": [
    {
      "id": "mw-wonder-1",
      "title": "Make a guess",
      "purpose": "Choose a testable idea",
      "blockIds": [
        "mw-wonder-hook",
        "mw-meet-kit",
        "mw-first-idea",
        "mw-first-prediction",
        "mw-swan-wonder",
        "mw-wonder-gate"
      ]
    }
  ],
  "magnetworks-explore": [
    {
      "id": "mw-explore-1",
      "title": "The tiny test",
      "purpose": "Test a chip on the table",
      "blockIds": [
        "mw-chip-setup",
        "mw-chip-trial"
      ]
    },
    {
      "id": "mw-explore-2",
      "title": "Test the barrier",
      "purpose": "Predict then test with thin cardboard",
      "blockIds": [
        "mw-card-invite",
        "mw-card-prediction",
        "mw-card-trial",
        "mw-swan-explore",
        "mw-explore-gate"
      ]
    }
  ],
  "magnetworks-understand": [
    {
      "id": "mw-understand-1",
      "title": "The evidence",
      "purpose": "Look back at your attempts",
      "blockIds": [
        "mw-explore-recall",
        "mw-contact-claim"
      ]
    },
    {
      "id": "mw-understand-2",
      "title": "A new idea",
      "purpose": "Predict a change",
      "blockIds": [
        "mw-distance-predict",
        "mw-swan-understand",
        "mw-understand-gate"
      ]
    }
  ],
  "magnetworks-apply": [
    {
      "id": "mw-apply-1",
      "title": "Prepare the car",
      "purpose": "Match and check the kit",
      "blockIds": [
        "mw-car-setup",
        "mw-car-photos",
        "mw-car-readiness"
      ]
    },
    {
      "id": "mw-apply-2",
      "title": "Pip’s first run",
      "purpose": "Predict and record the direction",
      "blockIds": [
        "mw-car-predict",
        "mw-car-trial",
        "mw-swan-apply",
        "mw-apply-gate"
      ]
    }
  ],
  "magnetworks-test-improve": [
    {
      "id": "mw-test-1",
      "title": "Remember trial one",
      "purpose": "Look closely at your first observation",
      "blockIds": [
        "mw-trial-a-recall",
        "mw-choose-change"
      ]
    },
    {
      "id": "mw-test-2",
      "title": "Plan one fair test",
      "purpose": "Predict before adjusting the wand",
      "blockIds": [
        "mw-second-predict",
        "mw-fair-test"
      ]
    },
    {
      "id": "mw-test-3",
      "title": "Compare outcomes",
      "purpose": "Do the next test or record why not",
      "blockIds": [
        "mw-second-trial",
        "mw-compare-trials",
        "mw-swan-improve",
        "mw-test-improve-gate"
      ]
    }
  ],
  "magnetworks-explain": [
    {
      "id": "mw-explain-1",
      "title": "Your explanation first",
      "purpose": "Describe what the tests suggest",
      "blockIds": [
        "mw-evidence-a-b",
        "mw-first-explanation"
      ]
    },
    {
      "id": "mw-explain-2",
      "title": "Learn from the science clue",
      "purpose": "Watch and explore the field lines",
      "blockIds": [
        "mw-science-video",
        "mw-fields-pwo"
      ]
    },
    {
      "id": "mw-explain-3",
      "title": "Think again",
      "purpose": "Compare your idea with your observation",
      "blockIds": [
        "mw-after-media",
        "mw-swan-explain",
        "mw-explain-gate"
      ]
    }
  ],
  "magnetworks-reflect": [
    {
      "id": "mw-reflect-1",
      "title": "Look back",
      "purpose": "See your own evidence",
      "blockIds": [
        "mw-original-prediction",
        "mw-reflection",
        "mw-science-habit",
        "mw-swan-reflect",
        "mw-reflect-gate"
      ]
    }
  ],
  "magnetworks-grow": [
    {
      "id": "mw-grow-1",
      "title": "Try a floating signal",
      "purpose": "Investigate a new push without touching",
      "blockIds": [
        "mw-floating-story",
        "mw-float-intro-photo",
        "mw-float-prediction",
        "mw-float-trial",
        "mw-float-photos",
        "mw-floating-link",
        "mw-swan-grow",
        "mw-grow-gate"
      ]
    },
    {
      "id": "mw-grow-2",
      "title": "Your next adventure — optional",
      "purpose": "Choose a return challenge or see an electric motor",
      "blockIds": [
        "mw-bonus-motor-story",
        "mw-motor-pwo",
        "mw-next-adventure"
      ]
    }
  ]
};
